import { Box, Flex, styled } from '@withjoy/joykit';

export const Container = styled(Box)`
  position: relative;
  width: 100%;
`;

export const InputContainer = styled(Flex)<{ $isFocused: boolean; $isDisabled: boolean }>`
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid ${({ theme, $isFocused }) => ($isFocused ? theme.colors.newUIBrandPrimary : theme.colors.mono5)};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'text')};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  transition: border-color 0.15s ease;

  ${({ theme, $isFocused }) =>
    $isFocused &&
    `
    box-shadow: 0 0 0 1px ${theme.colors.newUIBrandPrimary};
  `}
`;

export const Tag = styled(Flex)`
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-radius: 9999px;
  background-color: rgba(73, 81, 239, 0.1);
  color: ${({ theme }) => theme.colors.newUIBrandPrimary};
  font-size: 12px;
  font-weight: 500;
  max-width: 100%;
`;

export const TagLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.newUIBrandPrimary};
  cursor: pointer;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const InputWrapper = styled(Flex)`
  flex: 1;
  align-items: center;
  min-width: 0;
`;

export const StyledInput = styled.input`
  flex: 1;
  min-width: 40px;
  width: 0;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.mono14};

  &::placeholder {
    color: ${({ theme }) => theme.colors.mono8};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ChevronWrapper = styled(Box)<{ $isOpen: boolean }>`
  flex-shrink: 0;
  opacity: 0.6;
  transition: transform 0.15s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${({ theme }) => theme.colors.mono14};
`;

export const Dropdown = styled(Box)`
  position: absolute;
  z-index: 50;
  width: 100%;
  margin-top: 4px;
  border: 1px solid ${({ theme }) => theme.colors.mono3};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const DropdownList = styled(Box)`
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
`;

export const SuggestionHint = styled(Box)`
  padding: 8px 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.mono10};
  background-color: ${({ theme }) => theme.colors.mono2};
  border-bottom: 1px solid ${({ theme }) => theme.colors.mono3};
`;

export const OptionButton = styled.button<{ $isHighlighted: boolean }>`
  display: block;
  width: 100%;
  padding: 6px 8px;
  border: none;
  background-color: ${({ theme, $isHighlighted }) => ($isHighlighted ? theme.colors.mono14 : 'transparent')};
  color: ${({ theme, $isHighlighted }) => ($isHighlighted ? theme.colors.white : theme.colors.mono14)};
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme, $isHighlighted }) => ($isHighlighted ? theme.colors.mono14 : theme.colors.mono2)};
  }
`;

export const CreateOption = styled(OptionButton)`
  display: flex;
  align-items: center;
`;

export const Divider = styled(Box)`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.mono3};
  margin: 4px 8px;
`;

export const EmptyState = styled(Box)`
  padding: 24px 8px;
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.mono8};
`;
